module.exports = __webpack_public_path__ + "static/media/playpt1.dd908b96.png";